var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.news),function(news){return _c('v-flex',{key:news.id,attrs:{"xs12":""}},[_c('v-sheet',{staticClass:"ma-1",attrs:{"rounded":"","elevation":"1"}},[_c('NewsItem',{attrs:{"news":news}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }